// organization
export const organizationUrl = '/app/organization'
export const getOrganizationPage = () => `${organizationUrl}`
export const createOrganization = () => `${organizationUrl}`
export const updateOrganization = (id) => `${organizationUrl}/${id}`
export const deleteOrganization = (id) => `${organizationUrl}/${id}`

export const getOrganizationTree = (version) =>
  `${organizationUrl}/organization-tree?version=${version}`
export const getAllOrganization = (version) =>
  `${organizationUrl}/organization?version=${version}`
